// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveAwardTypeDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import AwardTypeDTO from '../models/AwardTypeDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    awardTypeId: number;
    awardType: AwardTypeDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            awardTypeId: 0,
            awardType: null,
        },
        initValues);
    },
    awardTypeId: 'awardTypeId',
    awardType: 'awardType',
}

interface Result extends ResultDTO {
    awardType: AwardTypeDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            awardType: null,
        },
        initValues);
    },
    awardType: 'awardType',
}

export { Request, Result };